module.exports = __webpack_public_path__ + "img/logo_login.03db8d7b.png";